export enum FaultNotificationPriority {
  NotSet = 0,
  Lowest = 1,
  Low = 2,
  Normal = 3,
  High = 4,
  Highest = 5,
}

export enum FaultNotificationStatus {
  New = 0,
  InProgress = 1,
  Resolved = 2,
  Cancelled = 3,
  Unread = 4,
  Active = 5,
}

export function FaultNotificationPriorityToString(priority: FaultNotificationPriority): string {
  switch (priority) {
    case FaultNotificationPriority.NotSet:
      return 'CONST.FAULT_NOTIFICATION_PRIORITY_NOTSET';

    case FaultNotificationPriority.Lowest:
      return 'CONST.FAULT_NOTIFICATION_PRIORITY_LOWEST';

    case FaultNotificationPriority.Low:
      return 'CONST.FAULT_NOTIFICATION_PRIORITY_LOW';

    case FaultNotificationPriority.Normal:
      return 'CONST.FAULT_NOTIFICATION_PRIORITY_NORMAL';

    case FaultNotificationPriority.High:
      return 'CONST.FAULT_NOTIFICATION_PRIORITY_HIGH';

    case FaultNotificationPriority.Highest:
      return 'CONST.FAULT_NOTIFICATION_PRIORITY_HIGHEST';

    default:
      throw new Error(`There is not conversion for '${priority}'.`);
  }
}

export function FaultNotificationStatusToString(status: FaultNotificationStatus, read: boolean): string {
  switch (status) {
    case FaultNotificationStatus.Cancelled:
      return 'CONST.FAULT_NOTIFICATION_STATUS_CANCELLED';

    case FaultNotificationStatus.InProgress:
      return 'CONST.FAULT_NOTIFICATION_STATUS_IN_PROGRESS';

    case FaultNotificationStatus.New: {
      if (read) return 'CONST.FAULT_NOTIFICATION_STATUS_NEW';
      else return 'CONST.FAULT_NOTIFICATION_STATUS_UNREAD';
    }

    case FaultNotificationStatus.Resolved:
      return 'CONST.FAULT_NOTIFICATION_STATUS_RESOLVED';

    case FaultNotificationStatus.Unread:
      return 'CONST.FAULT_NOTIFICATION_STATUS_UNREAD';

    case FaultNotificationStatus.Active:
      return 'CONST.FAULT_NOTIFICATION_STATUS_ACTIVE';

    default:
      throw new Error(`There is not conversion for '${status}'.`);
  }
}
